define.alias("shared/components/shared/card", "media/components/shared/card");